import ujs from '@rails/ujs'
ujs.start()

import '../globals/jquery'

import 'bootstrap'
import '@fortawesome/fontawesome-free/css/all.css'
